module.exports = __webpack_public_path__ + "static/media/job_frequency.4ab9801d.svg";